import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserInfo } from "../../../redux/actions/languiseAction";
import TextField from "../../TextField";
import { CustomSelect } from "../CustomSelect";
import { countryList } from "../../Languages";
import api from "../../../services/api";
import Notiflix from "notiflix";
import { useTranslation } from "react-i18next";

export default function ChangeAccountAddressModal({ openModal, closeModal }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.LanguiseReducer.userInfo);

  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [company, setCompany] = useState("");
  const [errorMessage, setErrorMessage] = useState({});

  useEffect(() => {
    setCountries([
      { label: t("changeAccountAddressModalText1"), value: "" },
      ...countryList,
    ]);
  }, []);
  useEffect(() => {
    if (user.country) {
      setCountry(user.country);
      setAddress(user.address);
      setPostalCode(user.postal_code);
      setCompany(user.company_name);
    }
  }, [user]);

  const changeAddress = () => {
    api
      .post("/user/address/", {
        company_name: company,
        country,
        address: address,
        postal_code: postalCode,
      })
      .then((rst) => {
        Notiflix.Notify.success(t("changeAccountAddressModalText2"));
        dispatch(getUserInfo());
        closeModal();
      })
      .catch((error) => {
        Notiflix.Notify.failure(t("operationFailure"));
        console.log(error);
      });
  };

  return (
    <div
      className={`${
        openModal
          ? "flex !opacity-100 !translate-y-0"
          : "hidden !opacity-0 !translate-y-10"
      } fixed inset-0 bg-black/40 z-30 !transition-all !ease-in-out !duration-300`}
    >
      <div className="flex flex-col max-w-[830px] w-full sm:mx-auto mx-5 my-auto z-[50] bg-[#F0F1F8] px-[12px] py-[12px] rounded-lg">
        <div className="flex justify-end">
          <img
            onClick={closeModal}
            className="w-[20px] h-[20px] cursor-pointer"
            src="/assets/cancel-modal.svg"
            alt="Cancel"
          />
        </div>
        <p className="text-[#4B5090] font-sans text-[20px] text-center mt-4">
          {t("changeAccountAddressModalText4")}
        </p>
        <div className="flex flex-col max-w-[420px] w-full mx-auto gap-4 mt-[37px]">
          <div className="flex flex-col gap-1">
            <p className="text-start font-sans text-[#505050] text-[12px]">
              {t("companyName")}
            </p>
            <TextField
              type="text"
              value={company}
              onChange={(e) => setCompany(e.target.value)}
            />
            <span className="text-start text-red-600 text-sm">
              {errorMessage.company}
            </span>
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-start font-sans text-[#505050] text-[12px]">
              {t("country")}
            </p>
            <CustomSelect
              value={country}
              onChange={setCountry}
              items={countries}
              className="h-[35px] sm:h-[40px]"
            />
            <span className="text-start text-red-600 text-sm">
              {errorMessage.country}
            </span>
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-start font-sans text-[#505050] text-[12px]">
              {t("address")}
            </p>
            <TextField
              type="text"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
            <span className="text-start text-red-600 text-sm">
              {errorMessage.address}
            </span>
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-start font-sans text-[#505050] text-[12px]">
              {t("postalCode")}
            </p>
            <TextField
              type="text"
              value={postalCode}
              onChange={(e) => setPostalCode(e.target.value)}
            />
            <span className="text-start text-red-600 text-sm">
              {errorMessage.postalCode}
            </span>
          </div>
          <div className="flex justify-center mt-[14px] mb-10">
            <button
              onClick={changeAddress}
              className="w-full bg-transparent h-[40px] border border-[#8B8B8B] text-[#8B8B8B] rounded-[10px] hover:bg-[#4B5090] hover:text-white"
            >
              {t("update")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
